import { Collapse, Stack, useTheme } from "@mui/material";
import { SubmissionStatus } from "generated-graphql/graphql";
import React, { memo } from "react";

import { SubmissionStatsOverview } from "./Overview";
import { RequirementReadinessIssuesSection } from "./Overview/RequirementReadinessIssuesSection";

interface StatsSectionProps {
  statsOpen: boolean;
  onStatusClick: (status: SubmissionStatus) => void;
  selectedStatus: SubmissionStatus | null;
  onStateClick: (state: string) => void;
  selectedState: string | null;
  onGeneratorStatusClick: (status: string) => void;
  selectedGeneratorStatus: string | null;
}

/**
 * Memoized stats section to prevent re-renders when filter bar or grid changes
 * Only re-renders when:
 * - statsOpen changes (collapse toggle)
 * - Chart selection states change
 * - Chart click handlers change (they're stable via useCallback)
 */
export const StatsSection = memo(function StatsSection({
  statsOpen,
  onStatusClick,
  selectedStatus,
  onStateClick,
  selectedState,
  onGeneratorStatusClick,
  selectedGeneratorStatus,
}: StatsSectionProps) {
  const theme = useTheme();

  return (
    <Collapse in={statsOpen}>
      <Stack
        id="submission-stats"
        px={2}
        pt={2}
        sx={{
          background: theme.palette.grey50.main,
        }}
      >
        <RequirementReadinessIssuesSection />
        <SubmissionStatsOverview
          onStatusClick={onStatusClick}
          selectedStatus={selectedStatus}
          onStateClick={onStateClick}
          selectedState={selectedState}
          onGeneratorStatusClick={onGeneratorStatusClick}
          selectedGeneratorStatus={selectedGeneratorStatus}
        />
      </Stack>
    </Collapse>
  );
});
